import {
    isArray,
    isDate,
    isDefined,
    isNumber,
    isObject,
    isString
} from "../services/common/object-util";

const serializeDate = function (a) {
    return { _type: a.constructor.name, value: a.toISOString() };
};

export const prune = (obj, includedProps = [], excludedProps = []) => {
    if (isString(obj)) {
        return obj;
    }

    if (isNumber(obj)) {
        return obj;
    }

    if (obj) {
        return Object.getOwnPropertyNames(obj)
            .filter((propName) => !excludedProps.includes(propName))
            .filter((propName) =>
                includedProps.length
                    ? includedProps.includes(propName)
                    : propName
            )
            .reduce(
                (a, b) => {
                    if (isDate(obj[b])) {
                        a[b] = serializeDate(obj[b]);
                    } else if (isArray(obj[b])) {
                        a[b] = obj[b].map(prune);
                    } else if (isObject(obj[b])) {
                        if (obj[b].toJSON) {
                            a[b] = prune(obj[b].toJSON());
                        } else {
                            a[b] = prune(obj[b]);
                        }
                    } else {
                        a[b] = obj[b];
                    }

                    return a;
                },
                {
                    // TODO: We might want to change this since minification will change the class names.
                    // Can be fixed by using terser plugin keep_classnames: true
                    _type: obj.constructor.name
                }
            );
    }

    return null;
};

export const revive = (obj, classMappings) => {
    try {
        if (isDefined(obj)) {
            const { _type } = obj;
            // delete obj._type;

            if (isString(obj)) {
                return obj;
            }

            if (classMappings[_type]) {
                const c = new classMappings[_type]();

                c.fromJSON(obj);

                return Object.getOwnPropertyNames(obj).reduce((a, b) => {
                    if (isDefined(obj[b])) {
                        if (Array.isArray(obj[b])) {
                            a[b] = obj[b].map((i) => revive(i, classMappings));
                        } else if (typeof obj[b] === "object") {
                            a[b] = revive(obj[b], classMappings);
                        } else {
                            a[b] = obj[b];
                        }
                    }

                    return a;
                }, c);
            } else if (_type === "Date") {
                return new Date(obj.value);
            } else if (_type === "Object") {
                return Object.getOwnPropertyNames(obj).reduce((a, b) => {
                    a[b] = revive(obj[b], classMappings);
                    return a;
                }, {});
            } else {
                return obj;
            }
        } else {
            return obj;
        }
    } catch (err) {
        console.error(err);
    }
};
